<div class="flex w-full border-t border-t-[#d3dce8b3] relative bg-white">
  @if(isCredentials || isDiscoveryType6 || isInstitutions){
  <div [class]="isCredentials ? 'w-[246px]' : isInstitutions ? 'w-[373px]' : 'w-[584px] relative'">
    <div
      [ngClass]="{
      'discovery-card-table-header-default-name  cursor-pointer relative w-full': formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase(),
      'discovery-card-table-header-disabled w-full relative': formInfo?.fid, 
      'discovery-card-table-header-edit  w-full relative': !formInfo?.fid && isEditInputField,
      'py-[6px]': true,
      'pr-[16px]': true,
      'pl-[12px]': true,
      
    }"
    >
      <div
        class="absolute w-full h-full left-0 z-50"
        (click)="toggleDisabled(); $event.stopPropagation()"
        [matTooltip]="
          formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase()
            ? 'Default template name is being used. We suggest adding a different name for better searchability.'
            : ''
        "
        style="pointer-events: none;"
      ></div>

      <mat-form-field
        style="width: 100%"
        appearance="fill"
        [ngClass]="{
          'discovery-card-table-header-default-name cursor-pointer w-full': formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase(),
        }"
        [class]="
          formInfo?.fid
            ? 'discovery-config-table-input-disabled h-[32px] w-[100%]'
            : isEditInputField
            ? 'discovery-config-table-input w-full'
            : 'discovery-config-table-input w-full discovery-config-table-input-before-edit'
        "
      >
        <input
          class="text-truncate"
          [matTooltip]="
            formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase()
              ? 'Default template name is being used. We suggest adding a different name for better searchability.'
              : ''
          "
          #nameInput
          matInput
          placeholder="Name"
          type="text"
          name="name"
          [(ngModel)]="formInfo.form_name"
          (input)="handleInput($event)"
          (change)="handleInputChange($event)"
          (blur)="toggleDisabled(true)"
          [disabled]="formInfo?.fid ? true : false"
        />
      </mat-form-field>
    </div>
  </div>
  }@else{
  <div [class]="path?.template && path?.template2 ? 'w-[192px]' : ' w-[333px] relative'">
    <div
      [ngClass]="{
        'discovery-card-table-header-default-name  cursor-pointer relative w-full': formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase(),
        'discovery-card-table-header-disabled w-full relative': formInfo?.fid, 
        'discovery-card-table-header-edit  w-full relative': !formInfo?.fid && isEditInputField,
        'py-[6px]': true,
        'pr-[16px]': true,
        'pl-[12px]': true,
        
      }"
    >
      <div
        class="absolute w-full h-full left-0 z-50"
        (click)="toggleDisabled(); $event.stopPropagation()"
        [matTooltip]="
          formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase()
            ? 'Default template name is being used. We suggest adding a different name for better searchability.'
            : ''
        "
        style="pointer-events: none;"
      ></div>
      <mat-form-field
        style="width: 100%"
        appearance="fill"
        [ngClass]="{
        'discovery-card-table-header-default-name cursor-pointer w-full': formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase(),
      }"
        [class]="
          formInfo?.fid
            ? 'discovery-config-table-input-disabled h-[32px] w-full'
            : isEditInputField
            ? 'discovery-config-table-input w-full'
            : 'discovery-config-table-input w-full discovery-config-table-input-before-edit'
        "
      >
        <input
          [matTooltip]="
            formInfo?.form_name?.toLowerCase() === path?.template?.toLowerCase()
              ? 'Default template name is being used. We suggest adding a different name for better searchability.'
              : ''
          "
          class="cursor-pointer relative z-50 h-full w-full text-truncate"
          #nameInput
          matInput
          placeholder="Name"
          type="text"
          name="name"
          [(ngModel)]="formInfo.form_name"
          (change)="handleInputChange($event)"
          (input)="handleInput($event)"
          (blur)="toggleDisabled(true)"
          [disabled]="formInfo?.fid ? true : false"
          style="width: 100%"
        />
      </mat-form-field>
    </div>
  </div>
  } @if(isCredentials){
  <div
    [class]="
      !isEditMemberSelect && !formInfo?.fid
        ? 'discovery-card-table-header py-[6px] px-[16px] w-[200px]'
        : 'py-[6px] px-[16px] w-[200px] border-x border-x-[#d3dce8b3] bg-white'
    "
  >
    <mat-form-field
      style="width: 100%"
      [class]="!isEditMemberSelect && !formInfo?.fid ? 'discovery-config-table-select w-full' : 'discovery-config-table-select-edit w-full'"
    >
      <mat-select
        #userSelect
        [(ngModel)]="selectedUsers"
        (ngModelChange)="selectedUsersChange()"
        (focus)="memberSelectInputKeyDown($event)"
        multiple
        panelClass="discovery-member-select-panel"
        [placeholder]="'Select Owner'"
        [matTooltip]="!isEditMemberSelect && !formInfo?.fid ? 'This field is incomplete' : ''"
      >
        <mat-select-trigger [class]="'text-[#18191C] font-semibold text-sm font-open-sans'">
          {{ selectedUsers.length ? displayMember() : 'Select Owners' }}
        </mat-select-trigger>
        <mat-option class="discovery-No-Checkbox">
          <div class="flex items-center mt-2">
            <div matPrefix class="matPrefix-search-icon mt-[-2px] mr-2"><img src="assets/images/search.svg" width="18px" height="17px" /></div>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="searchText"
              name="searchText"
              [placeholder]="'Search Owner'"
              type="text"
              class="w-[220px] text-[#C1C2C5] font-medium text-base font-open-sans"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (keyup)="$event.stopPropagation()"
              (input)="$event.stopPropagation()"
            />
            @if(searchText){
            <mat-icon matSuffix class="text-[#898F9E] text-xl font-medium p-0 cursor-pointer mr-0" (click)="searchText = ''">close</mat-icon>
            }
          </div>
        </mat-option>
        @if ((allUserConnections | addFilterUserDataList : []:searchText)?.length == 0 && searchText?.length &&
        !userObject?.name?.toLowerCase().includes(searchText?.toLowerCase())) {
        <mat-option class="discovery-No-Checkbox" disabled> No results found</mat-option>
        }@else {
        <div class="max-h-[280px] overflow-auto">
          @if(userObject?.id && (!searchText || userObject?.name?.toLowerCase().includes(searchText?.toLowerCase()))){
          <div class="border-b border-b-[#EBF0FA]">
            <mat-option [value]="userObject?.id" [disabled]="formInfo?.fid">
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ userObject?.name | capitalizeRomanNumerals }}
              </div>
            </mat-option>
          </div>
          @if((allUserConnections | addFilterUserDataList : []:searchText)?.length){
          <div class="text-[#898F9E] text-xs font-open-sans font-semibold h-[43px] px-[20px] content-center cursor-default">Other Connections</div>
          } }
          <mat-option
            (onSelectionChange)="memberChange($event)"
            *ngFor="let user of allUserConnections | addFilterUserDataList : [] : searchText"
            [value]="user?.user_id"
            [disabled]="user?.user_id == userObject.id"
          >
            <div>
              @if (user?.user_first_middle_name && !user?.isGroup) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
                <span>{{ user.relationship_name }}</span>
              </div>
              }@else if (user?.user_first_middle_name && user?.isGroup) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
              </div>
              }@else if (user?.first_middle_name) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.first_middle_name + ' ' + user?.last_name | capitalizeRomanNumerals }}
                <span>{{ user?.relationship_name }}</span>
              </div>
              }@else if (user?.name) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.name | capitalizeRomanNumerals }}
              </div>
              }
            </div>
          </mat-option>
        </div>
        }
      </mat-select>
      @if(!isEditMemberSelect && !formInfo?.fid){
      <mat-icon matSuffix class="text-[#EB5757] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }@else{
      <mat-icon matSuffix class="text-[#25508E] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }
    </mat-form-field>
  </div>
  }@else{ @if((path?.template && path?.template2)){
  <div
    [class]="
      formInfo?.fid
        ? 'discovery-card-table-header-disabled py-[6px] px-[16px] w-[140px] border-l border-l-[#d3dce8b3] mmy'
        : 'discovery-card-table-header-edit py-[6px] px-[16px] w-[140px] border-x border-x-[#d3dce8b3] bg-white'
    "
  >
    <mat-form-field [class]="formInfo?.fid ? 'discovery-type-select-disabled w-full' : 'discovery-type-select-edit w-full'" style="width: 100%">
      <mat-select
        name="type"
        [(ngModel)]="formInfo.type"
        (focus)="typeSelectInputKeyDown($event)"
        placeholder="Select Type"
        [panelClass]="'discovery-type-select-panel'"
        [disabled]="formInfo?.fid ? true : false"
      >
        <mat-option *ngFor="let item of formTypes" [value]="item.value">
          {{ item.value }}
        </mat-option>
      </mat-select>
      @if(formInfo?.fid){
      <mat-icon matSuffix class="text-[#898F9E] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }@else{
      <mat-icon matSuffix class="text-[#25508E] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }
    </mat-form-field>
  </div>
  } @if(path.data_type == 'Entities' || isOwnerRegisterDataType){
  <div
    [class]="
      !isEditMemberSelect && !formInfo?.fid
        ? 'discovery-card-table-header py-[6px] px-[16px] w-[200px]'
        : 'py-[6px] px-[16px] w-[200px] border-x border-x-[#d3dce8b3] bg-white'
    "
  >
    <mat-form-field
      [class]="!isEditMemberSelect && !formInfo?.fid ? 'discovery-config-table-select w-full' : 'discovery-config-table-select-edit w-full'"
    >
      <mat-select
        #userSelect
        [(ngModel)]="selectedUsers"
        (ngModelChange)="selectedUsersChange()"
        (focus)="memberSelectInputKeyDown($event)"
        multiple
        panelClass="discovery-member-select-panel"
        [placeholder]="isOwnerRegisterDataType ? 'Select Owners' : 'Select Members'"
        [matTooltip]="!isEditMemberSelect && !formInfo?.fid ? 'This field is incomplete' : ''"
      >
        <mat-select-trigger [class]="'text-[#18191C] font-semibold text-sm font-open-sans'">
          {{ selectedUsers.length ? displayMember() : isOwnerRegisterDataType ? 'Select Owners' : 'Select Members' }}
        </mat-select-trigger>
        <mat-option class="discovery-No-Checkbox">
          <div class="flex items-center mt-2">
            @if(isOwnerRegisterDataType){
            <div matPrefix class="matPrefix-search-icon mt-[-2px] mr-2">
              <img src="assets/images/blue-serch-stroke-width1.svg" width="18px" height="17px" />
            </div>
            }@else{
            <div matPrefix class="matPrefix-search-icon mt-[-2px] mr-2"><img src="assets/images/search-icon.svg" width="18px" height="17px" /></div>
            }
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="searchText"
              name="searchText"
              [placeholder]="isOwnerRegisterDataType ? 'Search Owner' : 'Search Member'"
              type="text"
              class="w-[220px] text-[#C1C2C5] font-medium text-base font-open-sans"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (keyup)="$event.stopPropagation()"
              (input)="$event.stopPropagation()"
            />
            @if(searchText){
            <mat-icon matSuffix class="text-[#898F9E] text-xl font-medium p-0 cursor-pointer mr-0" (click)="searchText = ''">close</mat-icon>
            }
          </div>
        </mat-option>
        @if ((allUserConnections | addFilterUserDataList : []:searchText)?.length == 0 && searchText?.length &&
        !userObject?.name?.toLowerCase().includes(searchText?.toLowerCase())) {
        <mat-option class="discovery-No-Checkbox" disabled> No results found</mat-option>
        }@else {
        <div class="max-h-[280px] overflow-auto">
          @if(userObject?.id && (!searchText || userObject?.name?.toLowerCase().includes(searchText?.toLowerCase()))){
          <div class="border-b border-b-[#EBF0FA]">
            <mat-option [value]="userObject?.id" [disabled]="formInfo?.fid">
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ userObject?.name | capitalizeRomanNumerals }}
              </div>
            </mat-option>
          </div>
          @if((allUserConnections | addFilterUserDataList : []:searchText)?.length){
          <div class="text-[#898F9E] text-xs font-open-sans font-semibold h-[43px] px-[20px] content-center cursor-default">Other Connections</div>
          } }
          <mat-option
            (onSelectionChange)="memberChange($event)"
            #matOption
            *ngFor="let user of allUserConnections | addFilterUserDataList : [] : searchText"
            [value]="user?.user_id"
            [disabled]="user?.user_id == userObject.id"
          >
            <div>
              @if (user?.user_first_middle_name && !user?.isGroup) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
                <span>{{ user.relationship_name }}</span>
              </div>
              }@else if (user?.user_first_middle_name && user?.isGroup) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
              </div>
              }@else if (user?.first_middle_name) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.first_middle_name + ' ' + user?.last_name | capitalizeRomanNumerals }}
                <span>{{ user?.relationship_name }}</span>
              </div>
              }@else if (user?.name) {
              <div class="text-[12px] font-semibold leading-normal font-open-sans text-[#53565B]">
                {{ user?.nick_name ?? user?.name | capitalizeRomanNumerals }}
              </div>
              }
            </div>
          </mat-option>
        </div>
        }
      </mat-select>
      @if(!isEditMemberSelect && !formInfo?.fid){
      <mat-icon matSuffix class="text-[#EB5757] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }@else{
      <mat-icon matSuffix class="text-[#25508E] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }
    </mat-form-field>
  </div>
  } @if((!isDiscoveryType6 && !isCredentials && !isOwnerRegisterDataType && path.data_type != 'Entities') || path?.template && path?.template2){
  <div
    [style.width]="isInstitutions ? '160px' : '200px'"
    [class]="
      isEditSelectedVault
        ? 'discovery-card-table-header-edit py-[6px] px-[16px] border-x border-x-[#d3dce8b3] bg-white'
        : 'discovery-card-table-header py-[6px] px-[16px]'
    "
  >
    <mat-form-field
      [class]="!isEditSelectedVault ? 'discovery-config-table-select w-full' : 'discovery-config-table-select-edit w-full'"
      style="width: 100%"
    >
      <mat-select
        [(ngModel)]="selectedVault"
        (focus)="selectInputKeyDown($event)"
        panelClass="discovery-member-select-panel"
        placeholder="Select Vault"
        [matTooltip]="!isEditSelectedVault ? 'This field is incomplete' : ''"
      >
        <mat-select-trigger [class]="'text-[#18191C] font-semibold text-sm font-open-sans'">
         {{ selectedVault ? displayVault() : 'Select Vault' }}
        </mat-select-trigger>
        <!-- Search Input -->
        <mat-option class="discovery-No-Checkbox">
          <div class="flex items-center mt-2">
            <div matPrefix class="matPrefix-search-icon mt-[-2px] mr-2">
              <img src="assets/images/blue-serch-stroke-width1.svg" width="18px" height="17px" />
            </div>
            <input
              matInput
              [(ngModel)]="searchText"
              name="searchText"
              placeholder="Search Vault"
              type="text"
              class="w-[220px] text-[#C1C2C5] font-medium text-base font-open-sans"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (keyup)="$event.stopPropagation()"
              (input)="$event.stopPropagation()"
            />
            @if(searchText){
            <mat-icon matSuffix class="text-[#898F9E] text-xl font-medium p-0 cursor-pointer mr-0" (click)="searchText = ''">close</mat-icon>
            }
          </div>
        </mat-option>

        <!-- No Results Found -->
        @if ((vaults | filterVaultListName:searchText)?.length == 0) {
        <mat-option class="discovery-No-Checkbox" disabled> No results found </mat-option>
        }@else {
        <div class="max-h-[280px] overflow-auto">
          @for (item of vaults | filterVaultListName : searchText; track item) {
          <mat-option [value]="item.id" style="padding: 12px 24px" (click)="selectVault(item)">
            <div class="flex gap-[8px]" style="align-items: center">
              <div class="bg-[#EBF0FA] h-[40px] w-[40px] rounded flex-center">
                @if (!item?.type) {
                <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                } @if (item?.type === 'personal') {
                <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                } @if (item?.type === 'shared') {
                <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/shared.svg" />
                } @if (item?.type === 'holding' || item?.type === 'trust' || item?.type === 'entity') {
                <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/entity.svg" />
                }
              </div>
              <div class="flex fl-col gap-[2px]">
                <div class="text-[#18191C] font-semibold text-xs">{{ handleVaultNameForMultipleNames(item?.name) | truncateStrPipe : 26 }}</div>
                <div class="text-[#707070] font-medium leading-3 text-[10px]">{{ item.type | titlecase }}</div>
              </div>
            </div>
          </mat-option>
          }
        </div>
        }
      </mat-select>

      <!-- Arrow Icon -->
     @if(!isEditSelectedVault){
      <mat-icon matSuffix class="text-[#EB5757] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }@else {
      <mat-icon matSuffix class="text-[#25508E] text-xl font-medium p-0">keyboard_arrow_down</mat-icon>
      }
    </mat-form-field>
  </div>
  } } @if(isDiscoveryType6 && !formInfo?.fid){
  <div
    [class]="
      isCredentials
        ? 'w-[237px] px-[8px] discovery-card-table-header-edit py-[6px]  flex justify-start items-center'
        : isDiscoveryType6
        ? 'w-[100px] px-[8px] discovery-card-table-header-edit py-[6px]  flex justify-start items-center'
        : 'w-[150px] px-[15px] discovery-card-table-header-edit py-[6px]  flex justify-start items-center'
    "
    [style.border-left]="isDiscoveryType6 ? '1px solid #d3dce8b3' : 'none'"
  >
    <div
      [class]="
        isCredentials || isDiscoveryType6 ? 'gap-[8px] flex justify-center items-center w-full' : 'gap-[12px] flex justify-center items-center w-full'
      "
    >
      <button
        class="h-8 px-4 bg-[#25508E] text-white rounded text-xs font-semibold font-['Open_Sans'] hover:bg-[#1e4275]"
        (click)="createFinancialAccount()"
      >
        Save
      </button>
    </div>
  </div>
  }@else {
  <div
    [class]="
      isCredentials
        ? 'w-[237px] px-[8px] discovery-card-table-header-edit py-[6px]  flex justify-start items-center'
        : isDiscoveryType6
        ? 'w-[100px] px-[8px] discovery-card-table-header-edit py-[6px]  flex justify-start items-center'
        : 'w-[150px] px-[15px] discovery-card-table-header-edit py-[6px]  flex justify-start items-center'
    "
    [style.border-left]="isDiscoveryType6 ? '1px solid #d3dce8b3' : 'none'"
  >
    <div [class]="isCredentials || isDiscoveryType6 ? 'gap-[8px] flex justify-center items-center' : 'gap-[12px] flex justify-center items-center'">
      @if(isDiscoveryType6){
      <button class="edit-btn" (click)="renameInstitutionName()">
        <img src="assets/images/edit-outlined.svg" width="20px" height="20px" />
      </button>
      <!-- <button
        [class]="!formInfo?.fid ? 'view-btn-disabled view-btn' : 'view-btn'"
        (click)="viewModal({ file: formInfo, event: $event })"
        [disabled]="!formInfo?.fid"
      >
        View
      </button> -->
      }@else { @if(isCredentials){ @if(formInfo.connection_status){
      <button class="connected-btn">
        <div><img class="h-[24px]" src="assets/images/account-link.svg" /></div>
        Connected
      </button>
      }@else{
      <div style="position: relative; z-index: 100;">
        <button
          [class]="!formInfo?.fid || isDialogOpen ? 'connect-btn-disabled connect-btn' : 'connect-btn'"
          (click)="onConnectButtonClick($event, formInfo)"
          [disabled]="!formInfo?.fid || isDialogOpen"
          [title]="!formInfo?.fid ? 'Connect button is disabled because form ID is not available' : isDialogOpen ? 'Connection dialog is already open' : 'Click to connect to financial institution'"
        >
          Connect
        </button>
      </div>
      } }

      <button
        [class]="!formInfo?.fid ? 'view-btn-disabled view-btn' : 'view-btn'"
        (click)="viewModal({ file: formInfo, event: $event })"
        [disabled]="!formInfo?.fid"
      >
        View
      </button>
      } @if(!formInfo?.fid || isDiscoveryType6){
      <button class="delete-btn" (click)="removeRow()">
        <img src="assets/images/trash-2.svg" width="20px" height="20px" />
      </button>
      }@else {
      <div>
        <button class="bg-transparent" (click)="removeRow()">
          <img src="assets/images/delete-outline.svg" class="bg-[#EB57571F] w-8 h-8 p-1 rounded-full" />
        </button>
      </div>
      }
    </div>
  </div>
  } @if(isLoadingRow) {
  <div class="w-[685PX] absolute top-0 loader-row">
    <div>
      <mat-spinner diameter="20"></mat-spinner>
    </div>
    <div>One moment while we save this</div>
  </div>
  }
</div>
@if (formData?.length) {
<div style="display: none">
  <edit-template-basic-form [Form1]="formData" [documentForm]="documentForm"> </edit-template-basic-form>
</div>
}
